import { flex } from "@styled-system/patterns";

export const wrapperClass = flex({
	alignItems: "center",
	cursor: "pointer",
	fontWeight: "bold",
	gap: "4",
});
